<template>
  <div class="p-0 absence-box">
    <div class="dates">
      <dod-custom-date-input
        :title="'Nieobecność od'"
        :minDate="getMinDateForNewSchedule()"
        :placeholder="dateFrom || 'Od'"
        :isRequired="true"
        @dateChange="(e) => (dateFrom = e)"
        :width="'175px'"
      />

      <dod-custom-date-input
        :title="'Nieobecność do'"
        :placeholder="dateTo || 'Do'"
        :minDate="getMinDateForNewSchedule()"
        :isRequired="true"
        @dateChange="(e) => (dateTo = e)"
        :width="'175px'"
      />
    </div>

    <div
      class="customers-after-absence-change my-4 ml-2 p-4"
      v-if="customersInGivenPeriod && customersInGivenPeriod.length > 0"
    >
      <p class="customer-label">
        Następujące osoby zostaną przeniesione do zakładki niepełny grafik:
      </p>
      <ul>
        <li
          class="customer-value"
          v-for="customer of customersInGivenPeriod"
          :key="customer"
        >
          {{ customer }}
        </li>
      </ul>
    </div>
    <div class="buttons-dates">
      <custom-button
        :gray="true"
        :title="'Anuluj'"
        :size="'small'"
        :radius="50"
        :customStyles="'width: 175px;'"
        @click="cancelEditing"
      />
      <custom-button
        :gradient="true"
        :title="'Zapisz'"
        :size="'small'"
        :radius="50"
        :customStyles="'width: 175px'"
        @click="saveEmployeeAbsence"
      />
    </div>
  </div>
</template>

<script>
import DodCustomDateInput from "./DodCustomDateInput.vue";
import moment from "moment";
import CustomButton from "../CustomButton.vue";
export default {
  components: { DodCustomDateInput, CustomButton },
  props: ["employeeId"],
  emits: ["cancel", "absenceAdded"],
  data() {
    return {
      dateFrom: "",
      dateTo: "",
    };
  },
  mounted() {
    this.dateFrom = this.getMinDateForNewSchedule();
    this.dateTo = this.getMinDateForNewSchedule();
  },
  methods: {
    getMinDateForNewSchedule() {
      return moment().add(1, "day").format("YYYY-MM-DD");
    },
    cancelEditing() {
      this.$emit("cancel");
    },
    async saveEmployeeAbsence() {
      const start = moment(this.dateFrom);
      const end = moment(this.dateTo);
      const allDates = [];
      let current = start.clone();
      while (current.isSameOrBefore(end)) {
        allDates.push(current.format("YYYY-MM-DD"));
        current.add(1, "day");
      }

      const response = await this.$store.dispatch("addEmployeeAbsences", {
        employeeId: this.employeeId,
        dates: allDates,
      });

      if (response) {
        await this.$store.dispatch("getEmployeeAbsences", {
          employeeId: this.employeeId,
        });
        this.$emit("absenceAdded", this.dateFrom);
      }
    },
  },

  watch: {},

  computed: {
    employeeOrders() {
      return this.$store.getters.getDodSelectedEmployeeOrders?.data || [];
    },
    customersInGivenPeriod() {
      let customers = [];
      const orders = this.employeeOrders;
      if (this.dateFrom && this.dateTo) {
        const dateStart = moment(this.dateFrom).startOf("day");
        const dateEnd = moment(this.dateTo).endOf("day");
        orders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            const date = moment(day.date).startOf("day");
            const customerName = `${order.customer.firstName} ${order.customer.lastName}`;
            if (
              !date.isBefore(dateStart) &&
              date.isBefore(dateEnd) &&
              !customers.includes(customerName)
            ) {
              customers.push(customerName);
            }
          });
        });
      }

      return customers;
    },
  },
};
</script>

<style  scoped>
.dates {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
}
.buttons-dates {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0;
  width: 100%;
}
.customers-after-absence-change {
  border-radius: 5px;
  background: linear-gradient(
      0deg,
      rgba(226, 3, 126, 0.07) 0%,
      rgba(226, 3, 126, 0.07) 100%
    ),
    #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>